<template>
  <div class="profile_container">
    <div class="profile_title">
      <label>活动名称</label>
      <p>{{ ruleForm.activityName }}</p>
    </div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" label-position="left" class="demo-ruleForm">
      <el-form-item label="报名手机号" prop="userMobile">
        <el-input disabled v-model="userMobileCode" readonly></el-input>
      </el-form-item>
      <el-form-item label="您的姓名" prop="userName">
        <el-input v-model="ruleForm.userName" placeholder="请输入您的姓名"></el-input>
      </el-form-item>
       <el-form-item label="意向老师">
        <el-select v-model="ruleForm.intentionTeacher" multiple placeholder="请选择" @change="handleChange">
          <el-option
            v-for="item in teacherNameList"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
      </el-select>
      <el-input style="margin-top:10px" v-if="otherTeachersShow" v-model="otherTeachers"
            class="el-checkbox-input" placeholder="请填写其他老师" maxlength="200"></el-input>
      </el-form-item>
      <!-- <el-form-item label="年龄" prop="userAge">
        <el-select v-model="ruleForm.userAge" placeholder="请选择您的年龄段">
          <el-option label="95后" value="95后"></el-option>
          <el-option label="90后" value="90后"></el-option>
          <el-option label="85后" value="85后"></el-option>
          <el-option label="80后" value="80后"></el-option>
          <el-option label="75后" value="75后"></el-option>
          <el-option label="70后" value="70后"></el-option>
          <el-option label="65后" value="65后"></el-option>
          <el-option label="60后" value="60后"></el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="您的性别" prop="userSex">
        <el-radio-group v-model="ruleForm.userSex">
          <el-radio label="男"></el-radio>
          <el-radio label="女"></el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="公司名称" prop="companyName">
        <el-input v-model="ruleForm.companyName"></el-input>
        <!-- <div class="clickSty" @click="openEVent">
          <span class="contentCom" :style="ruleForm.companyName == '请点击' ? 'color: #c4c8d0' : 'color: #000'"> {{
            ruleForm.companyName }}</span>
          <i class="el-icon-arrow-right" style="font-size: 14px;  color: #c4c8d0;"></i>
        </div> -->
        <!-- <div class="clickSty" @click="openEVent">
          <el-input disabled v-model="ruleForm.companyName" class="inputSty" placeholder="请点击">
          </el-input>
          <i class="el-icon-arrow-right iconRight"></i>
        </div> -->
      </el-form-item>
      <el-form-item label="人员规模" prop="number">
        <el-select v-model="ruleForm.number" placeholder="请选择" clearable>
            <el-option
                v-for="item in codeMap"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
        </el-select>
        <div class="company-industry">工商数据：{{ruleForm.size?ruleForm.size:'-'}}</div>
      </el-form-item>
      <el-form-item label="职位" prop="userPost">
        <!-- <el-input v-model="ruleForm.userPost"></el-input> -->
        <el-select v-model="ruleForm.userPost" placeholder="请选择您的职位">
          <el-option label="董事长" value="董事长"></el-option>
          <el-option label="总经理/CEO" value="总经理/CEO"></el-option>
          <el-option label="副总" value="副总"></el-option>
          <el-option label="总监" value="总监"></el-option>
          <el-option label="经理" value="经理"></el-option>
          <el-option label="其他" value="其他"></el-option>
        </el-select>
      </el-form-item>
       <el-form-item label="持股比例" prop="stakePercent">
        <el-select v-model="ruleForm.stakePercent" placeholder="请选择您的持股比例">
          <el-option label="0%" value="0%"></el-option>
          <el-option label="0%-30%" value="0%-30%"></el-option>
          <el-option label="30%-100%" value="30%-100%"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否决策人" prop="isDecisionMaker">
         <el-radio-group v-model="ruleForm.isDecisionMaker">
          <el-radio label="Y">是</el-radio>
          <el-radio label="N">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="公司行业" prop="companyIndustryList">
        <el-cascader v-model="ruleForm.companyIndustryList" placeholder="试试搜索：金融" :options="options" filterable clearable></el-cascader>
        <div class="company-industry">工商数据：{{companyIndustry ? companyIndustry:'-'}}</div>
      </el-form-item>
      <!-- <el-form-item label="成立时间" required>
        <el-col :span="24">
          <el-form-item prop="date1">
            <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="请选择公司成立时间" v-model="ruleForm.companyCreatTime"
              style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item> -->
      <el-form-item label="公司所在城市" prop="companyCity">
        <el-input v-model="ruleForm.companyCity" placeholder="请输入公司所在城市"></el-input>
      </el-form-item>
       <el-form-item label="主营产品" prop="companyMainBusiness">
        <el-input v-model="ruleForm.companyMainBusiness" maxlength="50" placeholder="请输入主营产品"></el-input>
      </el-form-item>
        <el-form-item label="公司年营业额" prop="annualIncome">
          <el-input style="width:150px;" v-model="ruleForm.annualIncome" placeholder="请输入营业额"></el-input><span style="margin-left:10px">万元</span> 
        <!-- <el-select v-model="ruleForm.annualIncome" placeholder="请选择您的年营业额">
          <el-option label="1000万以下" value="1000万以下"></el-option>
          <el-option label="1000-1999万元" value="1000-1999万元"></el-option>
          <el-option label="2000-3999万元" value="2000-3999万元"></el-option>
          <el-option label="4000-1亿元" value="4000-1亿元"></el-option>
          <el-option label="1亿-3亿" value="1亿-3亿"></el-option>
          <el-option label="3亿以上" value="3亿以上"></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="公司痛点" prop="companyUrgentProblemList" class="profile_item">
        <el-checkbox-group v-model="ruleForm.companyUrgentProblemList">
          <el-checkbox label="新的拓客方式" name="companyUrgentProblem" class="el-checkbox-block"></el-checkbox>
          <el-checkbox label="品牌升级" name="companyUrgentProblem" class="el-checkbox-block"></el-checkbox>
          <el-checkbox label="企业战略" name="companyUrgentProblem" class="el-checkbox-block"></el-checkbox>
          <el-checkbox label="股权问题" name="companyUrgentProblem" class="el-checkbox-block"></el-checkbox>
          <el-checkbox label="财税规划" name="companyUrgentProblem" class="el-checkbox-block"></el-checkbox>
          <el-checkbox label="组织发展" name="companyUrgentProblem" class="el-checkbox-block"></el-checkbox>
          <el-checkbox label="运营效率" name="companyUrgentProblem" class="el-checkbox-block"></el-checkbox>
          <el-checkbox label="新媒体营销" name="companyUrgentProblem" class="el-checkbox-block"></el-checkbox>
          <el-checkbox label="销售团队打造" name="companyUrgentProblem" class="el-checkbox-block"></el-checkbox>
          <el-checkbox label="商业模式" name="companyUrgentProblem" class="el-checkbox-block"></el-checkbox>
          <el-checkbox label="其他" name="companyUrgentProblem" class="el-checkbox-block"></el-checkbox>
          <el-input v-if="ruleForm.companyUrgentProblemList && ruleForm.companyUrgentProblemList.indexOf('其他') > -1" v-model="ruleForm.other"
            class="el-checkbox-input" placeholder="请填写其他企业问题" maxlength="200"></el-input>
        </el-checkbox-group>
      </el-form-item>
      <!-- <el-form-item label="您喜欢的意向讲师（例：曾任伟）" prop="intentionTeacher" class="profile_item">
        <el-input v-model="ruleForm.intentionTeacher" placeholder="请输入您喜欢的意向讲师"></el-input>
      </el-form-item>
      <el-form-item label="您是通过哪些方式/渠道了解到博商的？" prop="methodsAndChannels" class="profile_item">
        <el-input v-model="ruleForm.methodsAndChannels" placeholder="请输入您的了解方式/渠道"></el-input>
      </el-form-item>
      <el-alert class="profile_el_alert" title="如遇填写问题，请联系负责您业务的专属学习顾问" type="info">
      </el-alert> -->
      <el-form-item class="profile_item">
        <el-button class="submit_btn" type="primary" @click="submitForm('ruleForm')" v-if="ruleForm.auditStatus != '已通过'">
          确认无误并提交
        </el-button>
      </el-form-item>
    </el-form>


    <el-drawer :visible.sync="popupVisible" direction="btt" size="500px">
      <div class="diaSty">
        <div class="headSTy testSTY">
          <span @click="(popupVisible = !popupVisible)">取消</span>
          <span>公司名称</span>
          <span @click="saveEvent" style="color:#902a26 ">保存</span>
        </div>
        <div style="overflow: hidden;padding-top: 20px;">
          <el-input ref="pkgId" placeholder="搜索" v-model="searchValue" clearable size="small" :autofocus="true">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <!-- <mt-search class="searchSty" v-model="searchValue" cancel-text="取消" placeholder="搜索">
                        </mt-search> -->
          <!-- <mt-search v-model="value">
                            <mt-cell v-for="item in companyList" :title="item.name" :value="item.name">
                            </mt-cell>
                        </mt-search> -->
        </div>
        <div class="allCon" @click="handleEvent($event)">
          <!-- <div class="noData" v-if="companyList==null ||companyList.length==0">无数据</div> -->
          <div class="content" v-for="(item, index) in companyList" :key="index" :data-name="item.name">
            {{ item.name }}
          </div>
        </div>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import Common from '@/utils/common'
import customerService from '@/api/customerService'

export default {
  name: "profile",
  data: function () {
    return {
      options: [],
      teacherNameList: [],
      teacherNameDefault: ['先看看，不确定','其他'],
      otherTeachersShow:false,
      otherTeachers:'',
      codeMap: [],
      companyIndustry:'',
      areaCode:'',
      userMobileCode:'',
      ruleForm: {
        companyUrgentProblemList: [],
        userMobile: "",
        userName: "",
        // userAge: "",
        // userSex: "",
        number: "",
        companyName: "",
        userPost: "",
        stakePercent: "",
        annualIncome: "",
        companyCreatTime: "",
        companyCity: "",
        companyMainBusiness: "",
        isDecisionMaker: "Y",
        intentionTeacher:[],
        size:''
      },
      applyFormModel: { companyName: "请点击" },
      companyName: "",
      companyList: [
        // { name: 111 },
        // { name: 222 },
        // { name: 333 },
      ],
      popupVisible: false,
      drawer: true,
      searchValue: '',
      rules: {
        userName: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        userAge: [
          { required: true, message: '请选择您的年龄段', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请输入您的公司名称', trigger: 'change' }
        ],
        number: [
          { required: true, message: '请选择您的公司人数', trigger: 'blur' }
        ],
        stakePercent: [
          { required: true, message: '请选择您的持股比例', trigger: 'blur' }
        ],
        isDecisionMaker: [
          { required: true, message: '请选择是否决策人', trigger: 'blur' }
        ],
        // companyIndustryList: [
        //   { type: 'array', required: true, message: '请选择公司行业', trigger: 'blur' }
        // ],
        userPost: [
          { required: true, message: '请选择您的职位', trigger: 'blur' }
        ],
        annualIncome: [
          { required: true, message: '请选择您的年营业额', trigger: 'blur' }
        ],
        companyCreatTime: [
          { type: 'date', required: true, message: '请选择公司成立时间', trigger: 'blur' }
        ],
        companyCity: [
          { required: true, message: '请输入公司所在城市', trigger: 'blur' }
        ],
        companyMainBusiness: [
          { required: true, message: '请输入主营产品', trigger: 'blur' }
        ],
        annualIncome: [
          { required: true, message: '请输入年营业额', trigger: 'blur' }
        ],
        companyUrgentProblemList: [
          { type: 'array', required: true, message: '请至少选择一个企业问题', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    'searchValue': function (newValue, oldValue) {
      var vm = this;
      this.companyList = [];
      if (!newValue) return;
      customerService.getNewList(vm, newValue,vm.mobile).then((res) => {
        if (res) {
          if (Array.isArray(res)) {
            this.companyList = res
          } else {
            this.companyList.push(res)
          }
        }
      });
    },
    'popupVisible': function (newValue, oldValue) {
      if (newValue) {
        var vm = this;
        vm.$nextTick(() => {
          vm.$refs.pkgId.focus();
        })
      }
    },

  },
  mounted() {
    var vm = this;
    document.title = '大课登记表';
    vm.activityId = vm.$route.query.activityId;
    vm.mobile = vm.$route.query.mobile;
    vm.areaCode = vm.$route.query.areaCode;
    console.log(vm.activityId);
    vm.getLevelTypeList();
    vm.getCustomerInfo();
    vm.getValuesByCode();
  },
  methods: {
    getValuesByCode(){
      var vm = this;
          customerService.getValuesByCode(vm).then(function(codeMap){
          console.log(codeMap);
          vm.codeMap = codeMap;
      });
      },
    openEVent() {
      this.popupVisible = !this.popupVisible
    },
    handleChange() {
      const currentValue = this.ruleForm.intentionTeacher[this.ruleForm.intentionTeacher.length - 1];
      if(this.ruleForm.intentionTeacher.includes('其他')){
        this.otherTeachersShow = true
      }else{
         this.otherTeachersShow = false
      }
      if(currentValue == '先看看，不确定'){
        this.ruleForm.intentionTeacher = []
        this.ruleForm.intentionTeacher.push(currentValue)
        this.otherTeachersShow = false
      }else{
        for (let i = 0; i < this.ruleForm.intentionTeacher.length; i++) {
          if (this.ruleForm.intentionTeacher[i] == '先看看，不确定') {
            this.ruleForm.intentionTeacher.splice(i, 1);
            i--; // 每次删除元素后，需要将索引减一，以避免漏掉下一个元素
          }
      }
         console.log( this.ruleForm.intentionTeacher)
      }
    },
    saveEvent() {
      // this.companyValue = this.searchValue
      if (this.searchValue) {

        // this.applyFormModel.companyName = this.searchValue
        this.ruleForm.companyName = this.searchValue
        this.popupVisible = !this.popupVisible
      }
    },
    openEVent() {
      this.popupVisible = !this.popupVisible
      if (this.ruleForm.companyName) {
        this.searchValue = this.ruleForm.companyName
      }
      // if (this.ruleForm.userName) {
      //   this.popupVisible = !this.popupVisible
      // } else {
      //   Common.PageOperator.showPromptMsg(this, true, '请先输入 您的姓名', 'warning');
      // }

    },
    handleEvent(e) {
      var vm = this;
      if (e.target.className === 'content') {
        // this.applyFormModel.companyName = e.target.dataset.name

        this.ruleForm.number = ''
        this.ruleForm.userPost = ''
        this.ruleForm.stakePercent = ''
        this.ruleForm.annualIncome = ''
        this.ruleForm.companyCreatTime = ''
        this.ruleForm.companyCity = ''

        this.ruleForm.companyName = e.target.dataset.name
        this.ruleForm.companyName = e.target.dataset.name

        this.popupVisible = !this.popupVisible;
        customerService.getCompany(vm, this.ruleForm.companyName,this.ruleForm.userName).then((res) => {
          if (res.size) {
            // vm.ruleForm.number = res.size
            vm.ruleForm.size = res.size
          }
          // if (res.position) {
          //   vm.ruleForm.userPost = res.position  //学员职位
          // }
          if (res.stakePercent) {
            vm.ruleForm.stakePercent = res.specificStakePercent //持股比例
          }
          if (res.annualSales) {
            vm.ruleForm.annualIncome = res.annualSales    //年营业额
          }
          if (res.industryLevel1) {
            // vm.ruleForm.companyIndustryList=[]
            vm.ruleForm.companyIndustryList=res.industryLevel1 //所属行业
            vm.companyIndustry=res.industryLevel1 //所属行业
          }
          if (res.estiblishTime) {
            vm.ruleForm.companyCreatTime = res.estiblishTime  //成立时间
          }

          if (res.address.city) {
            vm.ruleForm.companyCity = res.address.city  //所在城市
          }
          vm.$forceUpdate()

        });
      }


    },
    inputEvent() {
      window.console.log('11',)
      // this.drawer=false
    },
    focusEvent() {
      this.drawer = true
      window.console.log('222',)
    },
    getCustomerInfo: function () {
      var vm = this;
      customerService.getInformationVO(vm, vm.activityId, vm.mobile, vm.areaCode).then(function (data) {
        if (!Common.Util.isEmpty(data.companyUrgentProblem)) {
          data.companyUrgentProblemList = [];
          var list = data.companyUrgentProblem.split(',');
          list.forEach(function (row) {
            if (row.indexOf('其他') > -1) {
              var otherList = row.split('$$');
              data.companyUrgentProblemList.push(otherList[0]);
              data.other = otherList[1];
            } else {
              data.companyUrgentProblemList.push(row);
            }
          });
        } else {
          data.companyUrgentProblemList = [];
        }
        if (!Common.Util.isEmpty(data.companyIndustry)) {
          data.companyIndustryList = data.companyIndustry.split('$$');
        } else {
          data.companyIndustryList = [];
        }
        if (Common.Util.isEmpty(data.userSex)) {
          data.userSex = '男';
        }
        data.userMobile = vm.mobile;
         vm.userMobileCode = '+'+vm.areaCode+'-'+vm.mobile;
        // data.areaCode = vm.areaCode;
        if(data.intentionTeacher){
        data.intentionTeacher = data.intentionTeacher.split(',')
        }
        vm.teacherNameList = data.teacherNameList.concat(vm.teacherNameDefault)
        // vm.ruleForm = data;
        vm.ruleForm = Object.assign(vm.ruleForm, data)
        if(!vm.ruleForm.informationCollectId){
          vm.ruleForm.number = ''
        }
        window.console.log('vm.ruleForm', vm.ruleForm )
        if (vm.ruleForm.companyName) {
          customerService.getCompany(vm, vm.ruleForm.companyName,vm.ruleForm.userName,vm.mobile).then((res) => {
            // if (res.size && !vm.ruleForm.number) {
            //   vm.ruleForm.number = res.size
            // }
            if(res.size){
              vm.ruleForm.size = res.size
            }
            // if (res.position && !vm.ruleForm.userPost) {
            //   vm.ruleForm.userPost = res.position  //学员职位
            // }
            if (res.stakePercent && !vm.ruleForm.stakePercent) {
              vm.ruleForm.stakePercent = res.specificStakePercent //持股比例
            }
            if (res.annualSales && !vm.ruleForm.annualIncome) {
              vm.ruleForm.annualIncome = res.annualSales    //年营业额
            }
            // if (res.industryLevel1 && !vm.ruleForm.companyIndustry) {
            //   vm.ruleForm.companyIndustry = res.industryLevel1  //所属行业
            // }
            if (res.industryLevel1) {
            // vm.ruleForm.companyIndustryList=[]
            vm.companyIndustry=res.industryLevel1 //所属行业
          }
            if (res.estiblishTime && !vm.ruleForm.companyCreatTime) {
              vm.ruleForm.companyCreatTime = res.estiblishTime  //成立时间
            }

            if (res.address.city && !vm.ruleForm.companyCity) {
              vm.ruleForm.companyCity = res.address.city  //所在城市
            }
            vm.$forceUpdate()

          });
        }
      });
    },
    submitForm(formName) {
      var vm = this;
      console.log('this.ruleForm', this.ruleForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Common.PageOperator.showConfirm(vm, '提示', '是否确认提交', '确认', '取消', function () {
            console.log(vm.ruleForm);
            if (vm.ruleForm.companyUrgentProblemList.indexOf('其他') > -1 && Common.Util.isEmpty(vm.ruleForm.other)) {
              Common.PageOperator.showPromptMsg(vm, true, '请填写【其他】对应的内容', 'warning');
              console.log("")
              return;
            }
            vm.ruleForm.companyUrgentProblem = vm.getCompanyUrgentProblemValue();
            if (vm.ruleForm.companyIndustryList && vm.ruleForm.companyIndustryList.length > 0) {
              console.log(vm.ruleForm.companyIndustryList.join('$$'));
              vm.ruleForm.companyIndustry = vm.ruleForm.companyIndustryList.join('$$');
            }
             if(vm.ruleForm.intentionTeacher.includes('其他')){
             vm.ruleForm.intentionTeacher = vm.ruleForm.intentionTeacher.concat(vm.otherTeachers.split(','))
            }
            for (let i = 0; i < vm.ruleForm.intentionTeacher.length; i++) {
            if (vm.ruleForm.intentionTeacher[i] == '先看看，不确定'||vm.ruleForm.intentionTeacher[i] == '其他') {
              vm.ruleForm.intentionTeacher.splice(i, 1);
              i--; // 每次删除元素后，需要将索引减一，以避免漏掉下一个元素
            }
            }
            //过滤
            var intentionTeacher = vm.ruleForm.intentionTeacher.join(',')
            var ruleForm = Common.Util.clone(vm.ruleForm);
            ruleForm.intentionTeacher = intentionTeacher
            delete ruleForm.companyUrgentProblemList;
            delete ruleForm.other;
            delete ruleForm.companyIndustryList;
            delete ruleForm.teacherNameList;
            delete ruleForm.size;
            console.log(ruleForm);
            customerService.saveInformationVO(vm, ruleForm).then(function (data) {
              vm.$router.push({ path: '/result', query: {} });
            });
          });
        } else {
          Common.PageOperator.showPromptMsg(vm, true, '提交失败', 'error');
          return false;
        }
      });
    },
    getCompanyUrgentProblemValue: function () {
      var vm = this;
      var list = [];
      if (vm.ruleForm.companyUrgentProblemList) {
        for (var i = 0, len = vm.ruleForm.companyUrgentProblemList.length; i < len; i++) {
          var ci = vm.ruleForm.companyUrgentProblemList[i];
          if (ci == '其他') {
            list.push(ci + '$$' + vm.ruleForm.other);
          } else {
            list.push(ci);
          }
        }
      }
      return list.join(',');
    },
    getLevelTypeList: function () {
      var vm = this;
      var levelType = 'COMPANY_LEVEL';
      return customerService.getLevelMap(vm, levelType).then(function (levelTypeMap) {
        var options = [];
        for (var pos in levelTypeMap) {
          var item = {
            value: pos,
            label: pos,
            children: []
          };
          if (levelTypeMap[pos]) {
            for (var childPos in levelTypeMap[pos]) {
              item.children.push({ value: childPos, label: childPos });
            }
          }
          options.push(item);
        }
        vm.options = options;
      });
    },
  },
}
</script>
<style>
.searchSty>.mint-searchbar {
  margin: 15px 0;
  background-color: #fff;
  border: 1PX solid #CCC;
  padding: 0 5px;
  height: auto;

}

.inputSty>.el-input__inner {
  /* border-right: none; */
  padding-right: 30px;
}

#el-drawer__title {
  display: none;
}

.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}

input,
input:focus,
textarea,
textarea:focus,
select,
select:focus {
  font-size: 16px !important;
}
</style>
<style scoped>
.profile_container {
  padding: 20px;
  overflow-x:hidden;
  overflow-y:auto;
  width:100vw;
  height:100vh;
}

.profile_title {
  margin-bottom: 22px;
}

.profile_title>label {
  text-align: left;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  width: 100px;
  display: block;
  box-sizing: border-box;
}

.profile_title>p {}


.diaSty {
  padding: 20px;
  height: 500px
}

.clickSty {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  /* padding-right: 10px; */
  height: 40px;
  /* border: 1px solid #DCDFE6; */
  border-radius: 4px;
  position: relative;
}

.iconRight {
  position: absolute;
  right: 10px;
  font-size: 14px;
  color: #c4c8d0;
}

.contentCom {
  font-size: 15px;
  padding-left: 15px;
  white-space: nowrap;
  overflow: hidden;
}

.headSTy {
  display: flex;
  justify-content: space-between;
  /* margin-top: 30px; */
  /* padding: 30px; */
  font-size: 16px;
  font-weight: 600;
}

.allCon {
  margin-top: 5px;
  height: 380px;
  /* overflow-y: auto; */
  overflow-y: scroll;
  /* background-color: rgba(228, 109, 228, 0.3); */
}

.content {
  line-height: 60px;
  font-size: 14px;
  font-weight: 600;
  margin: 0 9px;
  border-bottom: 1px solid #ccc;
}

.noData {
  /* height: 380px;
  line-height: 380px; */
  text-align: center;
  color: #CCC;
}
.company-industry{
  font-size: 12px ;
  color: red;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/profile.vue